import React from 'react'
import Header from '../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../component/custom-hooks/get-nav';

const TrackerLayout = () => {
  const navList = useNav();
  let { trackerTopHeaderNav, trackerBottomNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={trackerBottomNav} topTabs={trackerTopHeaderNav} />
      <Outlet />
    </div>
  )
}

export default TrackerLayout
